import { Switch, Route } from 'react-router-dom'
import { HomeMenu } from './components/HomeMenu/HomeMenu'
import { ContactMenu } from './components/ContactMenu/ContactMenu'
import { ActivityMenu } from './components/ActivityMenu/ActivityMenu'
import { BoxesMenu } from './components/BoxesMenu/BoxesMenu'

import './SideMenu.sass'

export function SideMenu () {
  return (
    <aside aria-label="Sidebar">
      <Switch>
        <Route exact path="/history" component={ActivityMenu} />
        <Route exact path="/contacts" component={ContactMenu} />
        <Route exact path="/" component={HomeMenu} />
        <Route exact path="/drafts" component={HomeMenu} />
        <Route exact path="/boxes" component={BoxesMenu} />
      </Switch>
    </aside>
  )
}
